const DEFAULT_WIDTH = 320;
const DEFAULT_GAP = 8;
const VIEWPORT_PADDING = 8;

/**
 * Compute fixed viewport coordinates for a popover anchored to a button.
 * Places below the anchor, right-aligned to the anchor's right edge.
 */
export function computeFixedPopoverPosition(
  anchorRect,
  {
    width = DEFAULT_WIDTH,
    estimatedHeight = 220,
    gap = DEFAULT_GAP,
    viewportWidth = typeof window !== 'undefined' ? window.innerWidth : 1024,
    viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 768,
  } = {},
) {
  if (!anchorRect) {
    return { top: VIEWPORT_PADDING, left: VIEWPORT_PADDING };
  }

  let top = anchorRect.bottom + gap;
  let left = anchorRect.right - width;

  if (left < VIEWPORT_PADDING) {
    left = VIEWPORT_PADDING;
  }
  if (left + width > viewportWidth - VIEWPORT_PADDING) {
    left = viewportWidth - width - VIEWPORT_PADDING;
  }

  if (top + estimatedHeight > viewportHeight - VIEWPORT_PADDING) {
    top = anchorRect.top - estimatedHeight - gap;
  }
  if (top < VIEWPORT_PADDING) {
    top = VIEWPORT_PADDING;
  }

  return { top, left };
}

export { DEFAULT_WIDTH as WORKFLOW_STATS_POPOVER_WIDTH };
